import { render, staticRenderFns } from "./PassChangeSuccessful.vue?vue&type=template&id=190d4384&scoped=true&"
import script from "./PassChangeSuccessful.vue?vue&type=script&lang=js&"
export * from "./PassChangeSuccessful.vue?vue&type=script&lang=js&"
import style0 from "./PassChangeSuccessful.vue?vue&type=style&index=0&id=190d4384&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190d4384",
  null
  
)

export default component.exports